import React, { useEffect, useState } from "react";
// import Image from "next/image";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import FormikInput from "@acko-tech/building-blocks.ui.form";
import InputField from "@components/inputField";
import Modal from "@components/modal";
import DOMPurify from "isomorphic-dompurify";
import {
  ContentWrapper,
  ErrorContainer,
  Errortext,
  HeadingText,
  IconContainer,
  SubmitModalWrapper,
  ThanksText,
} from "./styles";
import ThumbsUpIcon from "@public/images/icons/thumbs-up.svg";
import { useSelector } from "react-redux";
import ImageContainer from "@components/imageContainer";
import { sampleAnalytics, scrollIntoViewWrapper } from "@utils/index";
interface IMmvNotFoundModalProps {
  showModal: boolean;
  setShowModal: (val: boolean) => void;
  sampleVariantOfSelectedModal?: string;
  isDesktop?: boolean;
  mmvReportQuery?: string;
  lockBackgroundInteraction?: boolean;
}

interface FormatCTAtextProps {
  children?: React.ReactNode;
  htmlContent?: string;
  style?: React.CSSProperties;
}

export const FormatCTAtext: React.FC<FormatCTAtextProps> = ({
  children,
  htmlContent,
  style = {}
}) => {
  if (htmlContent) {
    return (
      <span
        style={{ fontFamily: "'Euclid Circular B', 'Inter', sans-serif", ...style }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  }
  return (
    <span style={{ fontFamily: "'Euclid Circular B', 'Inter', sans-serif", ...style }}>
      {children}
    </span>
  );
};

// TODO: Add validation and empty values check
const MmvNotFoundModal: React.FC<IMmvNotFoundModalProps> = ({
  showModal,
  setShowModal,
  sampleVariantOfSelectedModal,
  isDesktop,
  mmvReportQuery,
  lockBackgroundInteraction = true
}) => {
  const [modelName, setModelName] = useState<string>("");
  const [error, setError] = useState<any>("");
  const [isSubmitClicked, setIsSubmitClicked] = useState<boolean>(false);

  const { selectedModel } = useSelector(({ globalState }: any) => {
    return {
      selectedModel: globalState?.payloadData?.model || null
    };
  });

  const handleModalClick = () => {
    if (!modelName) {
      setError("This field is required");
    } else {
      setError("");
      const trimmed = modelName.trim();
      if (mmvReportQuery === "make") {
        sampleAnalytics(
          "action",
          "tap_btn",
          "tap_btn_car_not_found",
          {
            make_name: trimmed,
          }
        );
      }
      setIsSubmitClicked(true);
    }
  };

  useEffect(() => {
    if (showModal) {
      sampleAnalytics(
        "action",
        "view_modal",
        selectedModel
          ? "view_modal_select_model_modal"
          : "view_modal_select_make_modal",
        { state: "cannot_find_model" },
      );
    }
  }, [showModal]);

  const getModalHeading = () => {
    return selectedModel
      ? `Which car are you looking for?`
      : "Which car were you searching for?";
  };

  const getPlaceHolderText = () => {
    if (selectedModel && sampleVariantOfSelectedModal) {
      return sampleVariantOfSelectedModal;
    }
    return "eg: Mahindra XUV700";
  };

  return !isSubmitClicked ? (
    <>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        modalName="MmvNotFoundModal"
        modalHeading={getModalHeading()}
        modalHeadingStyles={{
          color: "#040222",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "28px",
          letterSpacing: "-0.1px",
          textAlign: "left",
          paddingBottom: !isDesktop ? "24px" : "0",
        }}
        bodyMargin="0px"
        isDesktop={isDesktop}
        styles={{
          maxHeight: "95%",
          overflow: "hidden !important",
          width: "500px",
          maxWidth: "100%",
        }}
        lockBackgroundInteraction={lockBackgroundInteraction}
      >
        <Flex flexDirection="column" style={{ gap: "2rem" }}>
          <FormikInput
            name="modelNameFormikInput"
            initialValue={modelName}
            handleNext={() => null}
            validate={(values) => {
              // TODO: ADD VALIDATION HERE
              const errors: { modelNameFormikInput?: string } = {};
              // if (!values.modelNameFormikInput) {
              //   errors.modelNameFormikInput = "This field is required";
              //   setError("This field is required");
              // }
              return errors;
            }}
            buttonText=""
            validateOnBlur
            customInput={({ ...props }: any) => (
              <InputField
                errors={{ ...error }}
                {...props}
                inputStyles={{
                  height: "3rem",
                  boxSizing: "border-box",
                }}
                inputContainerStyles={{
                  marginTop: "0.5rem",
                }}
                placeholder={getPlaceHolderText()}
                name="modelName"
                value={modelName}
                onChange={setModelName}
                onFocus={() => {
                  scrollIntoViewWrapper("modelNameFormikInput");
                }}
                customHandleBlur={() => {}}
                hideLabelText
                className="fs-exclude"
              />
            )}
            enableReinitialize
          />
          {error && (
            <ErrorContainer>
              {" "}
              <Errortext>{error}</Errortext>
            </ErrorContainer>
          )}
          <PrimaryButton isFullWidth onClick={handleModalClick}>
            <FormatCTAtext>Submit</FormatCTAtext>
          </PrimaryButton>
        </Flex>
      </Modal>
    </>
  ) : (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      isDesktop={isDesktop}
      hideCloseButton={isDesktop}
      bodyMargin="0px"
      styles={{}}
      lockBackgroundInteraction={lockBackgroundInteraction}
    >
      <SubmitModalWrapper>
        <IconContainer>
          <div style={{ height: "59px", width: "59px" }}>
            <ThumbsUpIcon height="100%" width="100%" />
          </div>
        </IconContainer>
        <ContentWrapper>
          <HeadingText>We’ve noted the issue</HeadingText>
          <ThanksText>
            Thank you for bringing this to our notice. We will investigate the
            issue, and fix it as soon as possible.
          </ThanksText>
        </ContentWrapper>
        <PrimaryButton
          isFullWidth
          onClick={() => {
            setShowModal(false);
            setIsSubmitClicked(false);
          }}
        >
          <FormatCTAtext>OK</FormatCTAtext>
        </PrimaryButton>
      </SubmitModalWrapper>
    </Modal>
  );
};

export default MmvNotFoundModal;
